// Code copied from @vueuse/gesture
// https://github.com/vueuse/gesture/blob/main/src/utils/rubberband.ts
const minMax = (value: number, min: number, max: number) => Math.max(min, Math.min(value, max));

// Based on @aholachek ;)
// https://twitter.com/chpwn/status/285540192096497664
// iOS constant = 0.55
// https://medium.com/@nathangitter/building-fluid-interfaces-ios-swift-9732bb934bf5
// default constant from the article is 0.7
const rubberband2 = (distance: number, constant: number) => distance ** (constant * 5);

const rubberband = (distance: number, dimension: number, constant: number) => {
	if (dimension === 0 || Math.abs(dimension) === Infinity) return rubberband2(distance, constant);
	return (distance * dimension * constant) / (dimension + constant * distance);
};

export const heightPercentToPixels = (heightStr: string, windowHeight: number) => (windowHeight * parseFloat(heightStr)) / 100;

export const rubberbandIfOutOfBounds = (position: number, min: number, max: number, constant = 0.15) => {
	if (constant === 0) return minMax(position, min, max);
	if (position < min) return -rubberband(min - position, max - min, constant) + min;
	if (position > max) return +rubberband(position - max, max - min, constant) + max;
	return position;
};

export const clamp = (value: number, { min, max }: { min?: number; max?: number }): number =>
	min !== undefined && value < min ? min : max !== undefined && value > max ? max : value;
